import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ShopProvider } from "@/context/ShopContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Wishlist from "@/pages/Wishlist";
import InfoPage from "@/pages/InfoPage";
import StyleGuide from "@/pages/StyleGuide";
import NavratriEdit from "@/pages/NavratriEdit";
import ComboBuilder from "@/pages/ComboBuilder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AdminAuthProvider, RequireAdmin } from "@/context/AdminAuth";

function App() {
  return (
    <ShopProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:handle" element={<Collection />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:orderNumber" element={<OrderSuccess />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/style/:slug" element={<StyleGuide />} />
            <Route path="/navratri-couple-edit" element={<NavratriEdit />} />
            <Route path="/combo" element={<ComboBuilder />} />
            <Route path="/pages/:page" element={<InfoPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminAuthProvider><AdminLogin /></AdminAuthProvider>} />
          <Route path="/admin" element={<AdminAuthProvider><RequireAdmin><AdminDashboard /></RequireAdmin></AdminAuthProvider>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </ShopProvider>
  );
}

export default App;
